import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {NgStyle} from "@angular/common";

@Component({
  selector: 'app-preloader',
  standalone: true,
  imports: [
    NgStyle
  ],
  templateUrl: './preloader.component.html',
  styleUrl: './preloader.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PreloaderComponent {
  @Input() width: string = '100%';
}
